'use client';

import { MouseEvent, useEffect, useState } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import classNames from 'classnames';
import { AppNextLink } from '@/features/app-next-link';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import AllProductsMenu from '@/components/header/components/mega-menu/all-products-menu';
import Brands from '@/components/header/components/mega-menu/brands';
import { IconArrowSquareDown } from '@/components/svg-symbols/icons';
import { useCategoryModal } from '../../category-modal/context/category-modal-context';
import { useLayoutMenu } from '../../utils/layout-menu';
export default function MegaMenu() {
  const {
    isMobile
  } = useMobileDetect();
  const {
    data: layoutMenu
  } = useLayoutMenu();
  const [isClosed, setIsClosed] = useState(false);
  const pathname = usePathname();
  const router = useRouter();
  const {
    close: closeCategoryModal
  } = useCategoryModal();

  // check if route changed, force close the menu
  useEffect(() => {
    setIsClosed(true);
    setTimeout(() => {
      // return opan-ability after a small amount of time user's route has changed
      setIsClosed(false);
    }, 200);
  }, [pathname]);
  const handleClickItem = (e: MouseEvent, itemHref: string) => {
    e.preventDefault();
    closeCategoryModal();
    router.replace(itemHref);
  };
  if (isMobile) return null;
  return <ul className='hide-scrollbar hidden h-full items-stretch overflow-x-auto text-sm font-medium text-white lg:flex [&>li:first-child]:pr-0 [&>li]:px-3' data-sentry-component="MegaMenu" data-sentry-source-file="mega-menu.tsx">
            <li className={classNames('flex cursor-pointer items-center whitespace-nowrap transition-all duration-100 ease-in-out hover:text-primary-shade-500', {
      group: !isClosed
    })}>
                دسته بندی محصولات
                <IconArrowSquareDown className='expand-more-icon h-6 w-6 transition-all duration-500 group-hover:rotate-180' data-sentry-element="IconArrowSquareDown" data-sentry-source-file="mega-menu.tsx" />
                <AllProductsMenu data-sentry-element="AllProductsMenu" data-sentry-source-file="mega-menu.tsx" />
            </li>

            {layoutMenu?.promotedUrl && <li className='flex cursor-pointer items-center whitespace-nowrap hover:text-primary-shade-500'>
                    <AppNextLink prefetch={false} href={layoutMenu?.promotedUrl || ''} className='flex items-center gap-1' onClick={e => handleClickItem(e, layoutMenu?.promotedUrl ?? '')}>
                        پیشنهاد ویژه
                    </AppNextLink>
                </li>}
            <li className={classNames('flex cursor-pointer items-center whitespace-nowrap transition-all duration-100 ease-in-out hover:text-primary-shade-500', {
      group: !isClosed
    })}>
                برندها
                <Brands type='desktop' data-sentry-element="Brands" data-sentry-source-file="mega-menu.tsx" />
            </li>
            <li className='flex cursor-pointer items-center whitespace-nowrap hover:text-primary-shade-500'>
                <AppNextLink prefetch={false} href='/videos' className='flex items-center gap-1' onClick={e => handleClickItem(e, '/videos')} data-sentry-element="AppNextLink" data-sentry-source-file="mega-menu.tsx">
                    جعبه جادویی
                </AppNextLink>
            </li>
            <li className='flex cursor-pointer items-center whitespace-nowrap hover:text-primary-shade-500'>
                <AppNextLink prefetch={false} href='https://www.khanoumi.com/blog/' className='flex items-center gap-1' onClick={e => handleClickItem(e, 'https://www.khanoumi.com/blog/')} data-sentry-element="AppNextLink" data-sentry-source-file="mega-menu.tsx">
                    مجله خانومی
                </AppNextLink>
            </li>
        </ul>;
}